const translations = {
    en: {
        translation: {
            NAV_HOME_TEXT: 'Home',
            NAV_NECKLACES_TEXT: 'Necklaces',
            NAV_BRACELETS_TEXT: 'Bracelets',
            NAV_EARRINGS_TEXT: 'Earrings',
            NAV_ABOUT_ME_TEXT: 'About me',
            NAV_CUSTOMS_TEXT: 'Customs',
            LOGIN_TEXT: 'Login',
            REGISTER_TEXT: 'Register',
            PROFILE_TEXT: 'Profile',
            LOGOUT_TEXT: 'Logout',
            EMAIL_TEXT: 'Email',
            PASSWORD_TEXT: 'Password',
            NO_ACCOUNT_TEXT: 'No account yet? Register',
            USERNAME_TEXT: 'Username',
            PASSWORD_CONFIRMATION_TEXT: 'Confirm password',
            FORM_FIELD_REQUIRED: 'This field is required',
            FORM_EMAIL_INVALID: 'Email address is invalid',
            NOT_AVAILABLE_BUTTON_TEXT: 'Item not available',
            CART_BUTTON_TEXT: 'Add to cart',
            EDIT_PRODUCT_BUTTON_TEXT: 'Edit product',
            DELETE_PRODUCT_BUTTON_TEXT: 'Delete product',
            EDIT_PRODUCT_TEXT: 'Edit product',
            IMAGES_TEXT: 'Images',
            SELECTED_IMAGE_TEXT: 'Selected image',
            CROP_IMAGE_BUTTON_TEXT: 'Crop image',
            ADD_IMAGE_BUTTON_TEXT: 'Add image',
            UPDATE_PRODUCT_BUTTON_TEXT: 'Update product',
            NAME_LABEL_TEXT: 'Name',
            PRICE_LABEL_TEXT: 'Price',
            DESCRIPTION_LABEL_TEXT: 'Description',
            QUANTITY_LABEL_TEXT: 'Quantity',
            IN_STOCK_LABEL_TEXT: 'In stock',
            CATEGORY_LABEL_TEXT: 'Category',
            EDIT_PRODUCT_ERROR_TEXT: 'Error editing Product',
            DELETE_IMAGE_ERROR_TEXT: 'Error deleting Image',
            SHIPPING_COST_DE_LABEL_TEXT: 'Shipping germany',
            SHIPPING_COST_EU_LABEL_TEXT: 'Shipping europe',
            SHIPPING_COST_INT_LABEL_TEXT: 'Shipping international',
            CREATE_PRODUCT_BUTTON_TEXT: 'Create product',
            CREATE_PRODUCT_TEXT: 'Create product',
            ERROR_PAGE_TEXT: 'An Error occurred pls try again later',
            CART_PAGE_HEADER_TEXT: 'Cart',
            CART_EMPTY_TEXT: 'Your cart is empty',
            CART_PAGE_QUANTITY_TEXT: 'Quantity',
            CART_PAGE_SUM_TEXT: 'Total',
            CART_PAGE_PAY_BUTTON_TEXT: 'Checkout',
            CHECKOUT_PAGE_HEADER_TEXT: 'Checkout',
            CHECKOUT_PAGE_ADDRESS_TEXT: 'Delivery address',
            STREET_LABEL_TEXT: 'Street',
            CITY_LABEL_TEXT: 'City',
            ZIP_CODE_LABEL_TEXT: 'Zip Code',
            ADDRESS2_LABEL_TEXT: 'Address line 2',
            REGION_LABEL_TEXT: 'Region or State',
            COUNTRY_LABEL_TEXT: 'Country',
            PAYMENT_METHOD_TEXT: 'Payment method',
            PAYPAL_LABEL_TEXT: 'PayPal',
            CREDIT_CART_LABEL_TEXT: 'Credit card',
            SHIPPING_COST_LABEL_TEXT: 'Shipping cost',
            CHECKOUT_PAGE_BUTTON_TEXT: 'Pay',
            ERROR_CREATING_ORDER: 'Order could not be created',
            ERROR_UPDATING_ORDER: 'Order could not be updated',
            ERROR_CREATING_STRIPE_PAYMENT_INTENT: 'Payment failed',
            ERROR_CONFIRMING_CARD_PAYMENT: 'Payment failed',
            KLARNA_PAYMENT_INFO_TEXT: "On Klarna payment the Email you use for the Klarna login is also used for the shipping address.",
            CHECKOUT_PAGE_KLARNA_BUTTON_TEXT: 'Pay with Klarna',
            KLARNA_PAYMENT_LABEL_TEXT: 'Klarna',
            ORDER_PAGE_HEADER: 'Order overview',
            UPDATE_ORDER_BUTTON: 'Edit order',
            SAVE_ORDER_BUTTON: 'Save order',
            PRODUCT_LABEL_TEXT: 'Product',
            COMMENT_LABEL_TEXT: 'Comment',
            SAVE_BUTTON_TEXT: 'Save',
            EDIT_BUTTON_TEXT: 'Edit',
            PROFILE_INFORMATION_TEXT: 'Profile information',
            ALL_ORDERS_TEXT: 'All orders',
            MY_ORDERS_TEXT: 'My orders',
            ORDER_NUMBER_TEXT: 'Order',
            ORDER_DATE_TEXT: 'Order date',
            STATE_SENT_TEXT: 'Status: shipped',
            STATE_NOT_SENT_TEXT: 'Status: preparing shipping',
            TRACKING_ID_TEXT: 'Tracking Id',
            TRACKING_ID_PLACEHOLDER_TEXT: 'Enter tracking Id',
            REVIEW_TEXT: 'Review',
            REVIEW_WITH_TEXT: 'Reviewed with',
            NO_ORDERS_TEXT: 'There are not orders yet',
            REGISTER_ERROR_TEXT: 'Error during registration',
            VERIFYING_MAIL_TEXT: 'Registering your email',
            VERIFICATION_EMAIL_SENT_TEXT: 'Verification email has been sent',
            CHECK_EMAIL_INSTRUCTIONS_TEXT: 'Please open your email inbox look for an email from ninakscreationss@gmail.com and click the link to verify your email',
            BACK_TO_LOGIN_TEXT: 'No verfication Mail recieved',
            PRIVACY_POLICY: 'Privacy Policy',
            GTC: 'GTCs',
            IMPRINT: 'Imprint',
            REVOCATION: 'Right of Withdrawal',
            RIGHTS_RESERVED: `Nina's Enchanting Creations all rights reserved.`,
            PRODUCTS: 'Products',
            REVIEWS: 'Reviews',
            PRIVACY_POLICY_CONSENT: 'I have read and I agree with the',
            GTC_CONSENT: 'I have read and I agree with the',
            PASSWORDS_NOT_MATCHING: 'Passwords do not match. Please try again.',
            OPEN_MENU: 'Open menu',
            SHOW_PASSWORD: 'Show password',
            DELETE_PRODUCT: 'Delete product',
            DELETE_IMAGE: 'Delete image',
            GENERAL_INFORMATION: 'General Information',
            GENERAL_INFORMATION_TEXT: 'My jewelry is for anyone who would like to carry a little more magic with them, and for anyone who wears extravagant and eye-catching jewelry just as much as I do. I hope you like this piece! \n' +
                '\n' +
                'If you have any questions or requests, you can contact me via Etsy or my Instagram account @ninakscreationss for custom orders and commissions.',
            CARE_INSTRUCTIONS: 'Care Instructions',
            MANUFACTURES_INFORMATION: 'Manufacturer\'s Information according to GPSR',
            MANUFACTURES_INFORMATION_TEXT: 'Nina\'s Enchanting Creation\'s, Nina Keck. Luisenstraße 39 - 76137 Karlsruhe. https://ninakcreations.de',
            MATERIALS: 'Materials',
            MYSTERY_BOXES_TEXT: 'Mystery boxes',
            NAME_DE_LABEL_TEXT: 'German Name',
            DESCRIPTION_DE_LABEL_TEXT: 'German Description',
            MATERIAL_DE: 'German Material',
            CARE_INSTRUCTIONS_DE: 'German Care Instructions',
            EDIT_GERMAN_TRANSLATION: 'Manual Translation',
            AUTO_GERMAN_TRANSLATION: 'Automatic Translation',
            SALES: 'Sales',
            SALE_FROM_TEXT: 'From',
            SALE_TO_TEXT: 'To',
            SALE_DISCOUNT_TEXT: 'Discount',
            CREATE_SALE: 'Create Sale',
            UPDATE_SALE: 'Update Sale',
            START_SALE: 'Start Sale',
            SALE_PRODUCTS_TEXT: 'Sale Products',
            INCLUDE_IN_SALE: 'Include',
            ADD_ALL_TO_SALE: 'Add all products',
            SALE_TEXT: 'Sale',
            SEARCH_PRODUCTS_TEXT: 'Search Product',
            EDITABLE_TIME_TEXT: 'The delivery address is only editable for 2 hours after your order! If you need to change your delivery address afterwards pls email us.',
            CARD_NUMBER_TEXT: 'Card Number',
            EXPIRY_TEXT: 'Expiry Date',
            CVC_TEXT: 'CVC',
            DIFFERENT_CARD_HOLDER_TEXT: 'Different card holder',
            CARD_HOLDER_TEXT: 'Card holder',
            NAV_RINGS_TEXT: 'Rings',
            CURRENCY_TEXT: 'Currency',
            CART_TEXT: 'Cart',
            VALID_DISCOUNT_CODES: 'Valid Discount Codes',
            DISCOUNT_CODE: 'Discount Code',
            DISCOUNT_PERCENT_TEXT: 'Discount',
            CREATE_DISCOUNT_CODE: 'Create Discount Code',
            ITEMS_PER_PAGE: 'Items per page',
            USE_DISCOUNT_CODE: 'Use',
            DISCOUNT_TILL: 'Valid till',
            INVALID_DISCOUNT: 'Invalid discount code',
            STERLING_SILVER: 'Sterling Silver',
            SHIPPING_CONDITIONS: 'Shipping Conditions',
            REVIEW_BY: 'Review By',
            EDIT_REVIEW: "Edit Review",
            ERROR_CREATING_REVIEW: "Error creating review",
            ERROR_UPDATING_REVIEW: "Error updating review",
            SHOW_ALL: "Show all products",
            STAINLESS_STEEL: "Stainless Steel"
        },
    },
    de: {
        translation: {
            NAV_HOME_TEXT: 'Home',
            NAV_NECKLACES_TEXT: 'Halsketten',
            NAV_BRACELETS_TEXT: 'Armbänder',
            NAV_EARRINGS_TEXT: 'Ohrringe',
            NAV_ABOUT_ME_TEXT: 'Über mich',
            NAV_CUSTOMS_TEXT: 'Aufträge',
            LOGIN_TEXT: 'Login',
            PROFILE_TEXT: 'Profil',
            LOGOUT_TEXT: 'Logout',
            EMAIL_TEXT: 'Email',
            PASSWORD_TEXT: 'Passwort',
            NO_ACCOUNT_TEXT: 'Noch keine Account? Registrieren',
            USERNAME_TEXT: 'Benutzername',
            PASSWORD_CONFIRMATION_TEXT: 'Passwort bestätigen',
            REGISTER_TEXT: 'Registrieren',
            FORM_FIELD_REQUIRED: 'Dieses Feld darf nicht leer sein',
            FORM_EMAIL_INVALID: 'Ungültige Email Adresse',
            NOT_AVAILABLE_BUTTON_TEXT: 'Artikel nicht verfügbar',
            CART_BUTTON_TEXT: 'Zum Warenkorb hinzufügen',
            EDIT_PRODUCT_BUTTON_TEXT: 'Produkt bearbeiten',
            DELETE_PRODUCT_BUTTON_TEXT: 'Produkt löschen',
            EDIT_PRODUCT_TEXT: 'Produkt bearbeiten',
            IMAGES_TEXT: 'Bilder',
            SELECTED_IMAGE_TEXT: 'Ausgewähltes Bild',
            CROP_IMAGE_BUTTON_TEXT: 'Zuschneiden',
            ADD_IMAGE_BUTTON_TEXT: 'Hinzufügen',
            UPDATE_PRODUCT_BUTTON_TEXT: 'Produkt aktualisieren',
            NAME_LABEL_TEXT: 'Name',
            PRICE_LABEL_TEXT: 'Preis',
            DESCRIPTION_LABEL_TEXT: 'Beschreibung',
            QUANTITY_LABEL_TEXT: 'Menge',
            IN_STOCK_LABEL_TEXT: 'Auf Lager',
            CATEGORY_LABEL_TEXT: 'Kategorie',
            EDIT_PRODUCT_ERROR_TEXT: 'Fehler beim Bearbeiten des Produktes',
            DELETE_IMAGE_ERROR_TEXT: 'Fehler beim Löschen des Bildes',
            SHIPPING_COST_DE_LABEL_TEXT: 'Lieferkosten Deutschland',
            SHIPPING_COST_EU_LABEL_TEXT: 'Lieferkosten Europa',
            SHIPPING_COST_INT_LABEL_TEXT: 'Lieferkosten International',
            CREATE_PRODUCT_BUTTON_TEXT: 'Produkt erstellen',
            CREATE_PRODUCT_TEXT: 'Produkt erstellen',
            ERROR_PAGE_TEXT: 'Es ist ein Fehler aufgetreten bitte versuchen sie es später erneut',
            CART_PAGE_HEADER_TEXT: 'Warenkorb',
            CART_EMPTY_TEXT: 'Dein Warenkorb ist leer',
            CART_PAGE_QUANTITY_TEXT: 'Menge',
            CART_PAGE_SUM_TEXT: 'Gesamt',
            CART_PAGE_PAY_BUTTON_TEXT: 'Zur Kasse',
            CHECKOUT_PAGE_HEADER_TEXT: 'Checkout',
            CHECKOUT_PAGE_ADDRESS_TEXT: 'Lieferadresse',
            STREET_LABEL_TEXT: 'Straße',
            CITY_LABEL_TEXT: 'Stadt',
            ZIP_CODE_LABEL_TEXT: 'Postleitzahl',
            ADDRESS2_LABEL_TEXT: 'Adresszeile 2',
            REGION_LABEL_TEXT: 'Region oder Staat',
            COUNTRY_LABEL_TEXT: 'Land',
            PAYMENT_METHOD_TEXT: 'Zahlungsmethode',
            PAYPAL_LABEL_TEXT: 'PayPal',
            CREDIT_CART_LABEL_TEXT: 'Kreditkarte',
            SHIPPING_COST_LABEL_TEXT: 'Versandkosten',
            CHECKOUT_PAGE_BUTTON_TEXT: 'Bezahlen',
            ERROR_CREATING_ORDER: "Die Bestellung konnte nicht erstellt werden",
            ERROR_UPDATING_ORDER: "Die Bestellung konnte nicht aktualisiert werden",
            ERROR_CREATING_STRIPE_PAYMENT_INTENT: 'Zahlung fehlgeschlagen',
            ERROR_CONFIRMING_CARD_PAYMENT: 'Zahlung fehlgeschlagen',
            KLARNA_PAYMENT_INFO_TEXT: 'bei Bezahlung mit Klarna wird die Mail Adresse die zum Login für Klarna verwendet wird auch zur Lieferadresse hinzugefügt',
            CHECKOUT_PAGE_KLARNA_BUTTON_TEXT: 'Mit Klarna bezahlen',
            KLARNA_PAYMENT_LABEL_TEXT: 'Klarna',
            ORDER_PAGE_HEADER: 'Bestellübersicht',
            UPDATE_ORDER_BUTTON: 'Bestellung bearbeiten',
            SAVE_ORDER_BUTTON: 'Bestellung speichern',
            PRODUCT_LABEL_TEXT: 'Produkt',
            COMMENT_LABEL_TEXT: 'Kommentar',
            SAVE_BUTTON_TEXT: 'Speichern',
            EDIT_BUTTON_TEXT: 'Bearbeiten',
            PROFILE_INFORMATION_TEXT: 'Profil Informationen',
            ALL_ORDERS_TEXT: 'Alle Bestellungen',
            MY_ORDERS_TEXT: 'Meine Bestellungen',
            ORDER_NUMBER_TEXT: 'Bestellnummer',
            ORDER_DATE_TEXT: 'Bestelldatum',
            STATE_SENT_TEXT: 'Status: versendet',
            STATE_NOT_SENT_TEXT: 'Status: Versand wird vorbereitet',
            TRACKING_ID_TEXT: 'Sendungsnummer',
            TRACKING_ID_PLACEHOLDER_TEXT: 'Sendungsnummer eingeben',
            REVIEW_TEXT: 'Bewerten',
            REVIEW_WITH_TEXT: 'Bewertet mit',
            NO_ORDERS_TEXT: 'Keine Bestellungen vorhanden',
            REGISTER_ERROR_TEXT: 'Fehler beim registrieren',
            VERIFYING_MAIL_TEXT: 'Registrieren ihrer E-Mail',
            VERIFICATION_EMAIL_SENT_TEXT: 'Registrierungs E-Mail wurde versendet',
            CHECK_EMAIL_INSTRUCTIONS_TEXT: 'Öffnen Sie ihr E-Mail Postfach schauen Sie nach einer Email von ninakscreationss@gmail.com und klicken Sie auf den Link um Ihre E-Mail zu bestätigen',
            BACK_TO_LOGIN_TEXT: 'Keine Resgistrierungs Email erhalten ?',
            PRIVACY_POLICY: 'Datenschutzerklärung',
            GTC: 'AGBs',
            IMPRINT: 'Impressum',
            REVOCATION: 'Widerruf',
            RIGHTS_RESERVED: 'Nina\'s Enchanting Creations alle Rechte vorbehalten',
            PRODUCTS: 'Produkte',
            REVIEWS: 'Bewertungen',
            PRIVACY_POLICY_CONSENT: 'Ich habe die Datenschutzerklärung gelesen und akzeptiere sie.',
            GTC_CONSENT: 'Ich habe die ABGs und die Widerrufsbelehrung gelesen und akzeptiere sie.',
            PASSWORDS_NOT_MATCHING: "Passwörter stimmen nicht überein. Bitte erneut versuchen.",
            OPEN_MENU: 'Menü anzeigen',
            SHOW_PASSWORD: 'Passwort anzeigen',
            DELETE_PRODUCT: 'Produkt löschen',
            DELETE_IMAGE: 'Bild löschen',
            GENERAL_INFORMATION: 'Allgemeine Informationen',
            GENERAL_INFORMATION_TEXT: 'Mein Schmuck ist für alle, die ein bisschen mehr Magie mit sich tragen möchten, und für alle, die extravaganten und auffälligen Schmuck genauso gerne tragen wie ich. Ich hoffe, dieses Stück gefällt Ihnen!\n' +
                '\n' +
                'Wenn Sie Fragen oder Wünsche haben, können Sie mich über Etsy oder meinen Instagram-Account @ninakscreationss für Sonderbestellungen und Auftragsarbeiten kontaktieren.',
            CARE_INSTRUCTIONS: 'Pflegehinweise',
            MANUFACTURES_INFORMATION: 'Herstellerangaben nach GPSR',
            MANUFACTURES_INFORMATION_TEXT: 'Nina\'s Enchanting Creation\'s \n Nina Keck \n Luisenstraße 39 \n 76137 Karlsruhe \n https://ninakcreations.de',
            MATERIALS: 'Materialien',
            MYSTERY_BOXES_TEXT: 'Mystery Boxen',
            NAME_DE_LABEL_TEXT: 'Deutscher Name',
            DESCRIPTION_DE_LABEL_TEXT: 'Deutsche Beschreibung',
            MATERIAL_DE: 'Deutsch Materialien',
            CARE_INSTRUCTIONS_DE: 'Deutsche Pflegehinweise',
            EDIT_GERMAN_TRANSLATION: 'Manuelle Übersetzung',
            AUTO_GERMAN_TRANSLATION: 'Automatische Übersetzung',
            SALES: 'Sales',
            SALE_FROM_TEXT: 'Von',
            SALE_TO_TEXT: 'Bis',
            SALE_DISCOUNT_TEXT: 'Rabatt',
            CREATE_SALE: 'Sale erstellen',
            UPDATE_SALE: 'Sale aktualisieren',
            START_SALE: 'Sale starten',
            SALE_PRODUCTS_TEXT: 'Produkte',
            INCLUDE_IN_SALE: 'Hinzufügen',
            ADD_ALL_TO_SALE: 'Alle Produkte hinzufügen',
            SALE_TEXT: 'Sale',
            SEARCH_PRODUCTS_TEXT: 'Produkt suchen',
            EDITABLE_TIME_TEXT: "Die Lieferadresse kann bis zu 2 Stunden nach Ihrer Bestellung geändert werden! Wenn Sie danach Änderungen benötigen, schreiben Sie uns bitte eine E-Mail.",
            CARD_NUMBER_TEXT: 'Kartennummer',
            EXPIRY_TEXT: 'Ablaufdatum',
            CVC_TEXT: 'Prüfziffer',
            DIFFERENT_CARD_HOLDER_TEXT: 'Abweichender Karteninhaber',
            CARD_HOLDER_TEXT: 'Karteninhaber',
            NAV_RINGS_TEXT: 'Ringe',
            CURRENCY_TEXT: 'Währung',
            CART_TEXT: 'Warenkorb',
            VALID_DISCOUNT_CODES: 'Gültige Rabattcodes',
            DISCOUNT_CODE: 'Rabattcode',
            DISCOUNT_PERCENT_TEXT: 'Rabatt',
            CREATE_DISCOUNT_CODE: 'Rabattcode erstellen ',
            ITEMS_PER_PAGE: 'Produkte pro Seite',
            USE_DISCOUNT_CODE: 'Einlösen',
            DISCOUNT_TILL: 'Gültig bis',
            INVALID_DISCOUNT: 'Ungültiger Rabattcode',
            STERLING_SILVER: 'Sterling Silber',
            SHIPPING_CONDITIONS: "Versandbedingungen",
            REVIEW_BY: "Bewertung von",
            EDIT_REVIEW: "Bewertung bearbeiten",
            ERROR_CREATING_REVIEW: "Fehler beim Erstellen der Bewertung",
            ERROR_UPDATING_REVIEW: "Fehler beim Bearbeiten der Bewertung",
            SHOW_ALL: "Alle Produkte anzeigen",
            STAINLESS_STEEL: "Edelstahl"
        },
    },
};

export default translations;
